module.exports = __webpack_public_path__ + "img/16.366d8021.webp";